// Tenants API — wraps /api/platform/tenants/*. Platform-staff scoped.

import { http } from '../../api/http';
import type { Tenant, CreateTenantInput } from '../../api/types';

export interface ListTenantsParams {
  status?: 'active' | 'provisioning' | 'suspended' | 'deleted';
  search?: string;
}

export const tenantsApi = {
  list: (params?: ListTenantsParams) =>
    http.get<Tenant[]>('/platform/tenants', { params }),

  /** Returns the tenant in its current state (poll while status=provisioning). */
  get: (slug: string) =>
    http.get<Tenant>(`/platform/tenants/${encodeURIComponent(slug)}`),

  /**
   * Creates a tenant. Returns 202 with status='provisioning'; the schema
   * is created and migrated asynchronously. Caller should poll get(slug)
   * (or invalidate the list query) until status flips to 'active'.
   */
  create: (input: CreateTenantInput) =>
    http.post<Tenant, CreateTenantInput>('/platform/tenants', input),
};
